import { Head, usePage } from "@inertiajs/react"
import { AppShell } from "@/components/AppShell"
import { PageHeader } from "@/components/PageHeader"
import { FlashNotice } from "@/components/admin/FlashNotice"
import type { PageProps } from "@/types/inertia"

const DESCRIPTION =
  "Your home in the IUPAT Portal — the tools available to you, and the organization you belong to."

export default function Dashboard() {
  const { props } = usePage<PageProps>()
  const user = props.current_user

  // The greeting names the person's own organization, not whichever one they
  // happen to be viewing in Automations.
  const name = user?.name ?? "there"
  const greeting = user?.org ? `Hello ${name} from ${user.org}` : `Hello ${name}`

  return (
    <>
      <Head title="Home">
        <meta name="description" content={DESCRIPTION} />
        <meta property="og:title" content="Home" />
        <meta property="og:description" content={DESCRIPTION} />
      </Head>
      <AppShell>
        <PageHeader
          title={greeting}
          description={
            user?.org
              ? "Everything IUPAT staff use, in one place."
              : "You're not attached to an organization yet — ask an admin to check your Duo profile."
          }
        />

        {/*
          The dashboard is where the gating concerns bounce people to, each with
          an alert explaining why. Nothing rendered those alerts until now, so a
          District Council user typing a Weekly Reports address — and, before
          that, anyone RequiresOrganization turned away — simply landed here with
          no explanation.
        */}
        <div className="mt-6">
          <FlashNotice />
        </div>
      </AppShell>
    </>
  )
}
